module.exports = __webpack_public_path__ + "img/image-3.97b1875c.png";